<template>
  <b-modal
    :id="modalName"
    size="lg"
    hide-footer
    hide-header
    centered
    title="Emitir"
    @hide="closeModal"
  >
    <div>
      <div :class="`headerModal`" style="background-color: #f5f9f">
        <div
          style="
            display: flex;
            align-items: center;
            gap: 1rem;
            position: relative;
          "
        >
          <div>
            <h6 class="titleModal">Venda Nº {{ getSale?.numero }}</h6>

            <p
              style="
                margin: 0;
                color: gray;
                font-size: 0.7rem;
                font-weight: 500;
              "
            >
              Detalhes completos da venda
            </p>
          </div>

          <div style="width: 30px; height: 30px">
            <div class="contentCloseIcon" @click="$bvModal.hide(modalName)">
              <b-icon-x-lg style="width: 12px; height: 12px; color: red" />
            </div>
          </div>
        </div>
      </div>

      <div class="bodyModal" style="background-color: #f5f9f">
        <div style="width: 100%; display: flex; gap: 1rem">
          <div class="customCard">
            <div>
              <p class="titleCard">Total da Venda</p>
              <p class="subtitleCard">{{ maskCurrency(handleGetTotal()) }}</p>
            </div>

            <div
              class="contentIcon"
              style="
                color: #0f74c5;
                background-color: color-mix(in oklab, #0f74c5 10%, transparent);
              "
            >
              <b-icon-credit-card2-back-fill />
            </div>
          </div>

          <div class="customCard">
            <div>
              <p class="titleCard">Valor Pago</p>
              <p class="subtitleCard">
                {{ maskCurrency(handleGetTotalsBill()) }}
              </p>
            </div>

            <div
              class="contentIcon"
              style="
                color: green;
                background-color: color-mix(in oklab, green 10%, transparent);
              "
            >
              <b-icon-check-circle-fill />
            </div>
          </div>

          <div class="customCard">
            <div>
              <p class="titleCard">Valor Pendente</p>
              <p class="subtitleCard">
                {{ maskCurrency(handleGetTotal() - handleGetTotalsBill()) }}
              </p>
            </div>

            <div
              class="contentIcon"
              style="
                color: black;
                background-color: color-mix(in oklab, orange 20%, transparent);
              "
            >
              <b-icon-clock />
            </div>
          </div>
        </div>

        <div style="width: 100%; display: flex; gap: 1rem">
          <div
            class="customCard"
            style="
              flex-direction: column;
              align-items: flex-start;
              justify-content: center;
              gap: 0.8rem;
              padding: 0 0 0.8rem 0;
            "
          >
            <div
              style="
                display: flex;
                gap: 0.5rem;
                align-items: center;
                padding: 0.8rem 1.2rem 0 1.2rem;
              "
            >
              <div
                style="
                  color: #0f74c5;
                  background-color: color-mix(
                    in oklab,
                    #0f74c5 10%,
                    transparent
                  );
                "
              >
                <b-icon-file-earmark-text-fill scale="1.1" />
              </div>

              <p
                style="
                  font-size: 0.8rem;
                  font-weight: 600;
                  font-family: Poppins-Medium !important;
                  color: #313131;
                  margin: 0;
                "
              >
                Informações Básicas
              </p>
            </div>

            <div
              style="
                display: flex;
                width: 100%;
                flex-direction: column;
                gap: 1rem;
                margin-top: 0.8rem;
              "
            >
              <div
                style="
                  display: flex;
                  width: 100%;
                  flex-wrap: wrap;
                  align-items: center;
                "
              >
                <div class="contentIconAndText">
                  <div class="basicInfoIcon">
                    <b-icon-calendar3 scale="0.8" />
                  </div>

                  <div class="contentTitleAndSubtitle">
                    <p
                      class="titleCard"
                      style="font-size: 0.65rem; line-height: 1.2"
                    >
                      Data
                    </p>
                    <p class="subtitleItems">{{ getSale?.data }}</p>
                  </div>
                </div>

                <div class="contentIconAndText">
                  <div class="basicInfoIcon">
                    <b-icon-hash scale="1" />
                  </div>

                  <div class="contentTitleAndSubtitle">
                    <p
                      class="titleCard"
                      style="font-size: 0.65rem; line-height: 1.2"
                    >
                      Nº Venda
                    </p>
                    <p class="subtitleItems">{{ getSale?.numero }}</p>
                  </div>
                </div>

                <div class="contentIconAndText">
                  <div class="basicInfoIcon">
                    <b-icon-cart4 scale="0.8" />
                  </div>

                  <div class="contentTitleAndSubtitle">
                    <p
                      class="titleCard"
                      style="font-size: 0.65rem; line-height: 1.2"
                    >
                      Status
                    </p>
                    <p class="subtitleItems">{{ getSale?.status }}</p>
                  </div>
                </div>

                <div class="contentIconAndText">
                  <div class="basicInfoIcon">
                    <b-icon-file-earmark-text scale="0.8" />
                  </div>

                  <div class="contentTitleAndSubtitle">
                    <p
                      class="titleCard"
                      style="font-size: 0.65rem; line-height: 1.2"
                    >
                      CPF/CNPJ
                    </p>
                    <p class="subtitleItems">{{ getSale?.cpfCnpj }}</p>
                  </div>
                </div>

                <div class="contentIconAndText">
                  <div class="basicInfoIcon">
                    <b-icon-person scale="0.9" />
                  </div>

                  <div class="contentTitleAndSubtitle">
                    <p
                      class="titleCard"
                      style="font-size: 0.65rem; line-height: 1.2"
                    >
                      Cliente
                    </p>
                    <p class="subtitleItems">{{ getSale?.nomeCliente }}</p>
                  </div>
                </div>

                <div class="contentIconAndText">
                  <div class="basicInfoIcon">
                    <b-icon-person-bounding-box scale="0.8" />
                  </div>

                  <div class="contentTitleAndSubtitle">
                    <p
                      class="titleCard"
                      style="font-size: 0.65rem; line-height: 1.2"
                    >
                      Funcionário
                    </p>
                    <p class="subtitleItems">
                      {{ getSale?.nomeFuncionario || "Não informado" }}
                    </p>
                  </div>
                </div>

                <div
                  class="contentIconAndText"
                  v-if="getSale?.tipo !== 'Pedido' && getSale?.tipo !== 'PDV'"
                >
                  <div class="basicInfoIcon">
                    <b-icon-person-square scale="0.8" />
                  </div>

                  <div class="contentTitleAndSubtitle">
                    <p
                      class="titleCard"
                      style="font-size: 0.65rem; line-height: 1.2"
                    >
                      Responsável técnico
                    </p>
                    <p class="subtitleItems">
                      {{ getSale?.nomeTecnico || "Não informado" }}
                    </p>
                  </div>
                </div>

                <div
                  class="contentIconAndText"
                  v-if="getSale?.tipo !== 'Pedido' && getSale?.tipo !== 'PDV'"
                >
                  <div class="basicInfoIcon">
                    <b-icon-layout-text-sidebar-reverse scale="0.8" />
                  </div>

                  <div class="contentTitleAndSubtitle">
                    <p
                      class="titleCard"
                      style="font-size: 0.65rem; line-height: 1.2"
                    >
                      Nº Receita
                    </p>
                    <p class="subtitleItems">
                      {{
                        `${getSale?.complementoReceita || ""}${
                          getSale?.receita || "Não informado"
                        }`
                      }}
                    </p>
                  </div>
                </div>

                <div
                  class="contentIconAndText"
                  v-if="getSale?.tipo !== 'Pedido' && getSale?.tipo !== 'PDV'"
                >
                  <div class="basicInfoIcon">
                    <b-icon-layout-text-sidebar scale="0.8" />
                  </div>

                  <div class="contentTitleAndSubtitle">
                    <p
                      class="titleCard"
                      style="font-size: 0.65rem; line-height: 1.2"
                    >
                      ART/TRT
                    </p>
                    <p class="subtitleItems">
                      {{ getSale?.art || "Não informado" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="customCard"
          style="
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 0.8rem;
            padding: 0 0 0.8rem 0;
          "
        >
          <div
            style="
              display: flex;
              gap: 0.5rem;
              align-items: center;
              padding: 0.8rem 1.2rem 0 1.2rem;
            "
          >
            <div style="color: #0f74c5">
              <b-icon-box-seam scale="1.1" />
            </div>

            <p
              style="
                font-size: 0.8rem;
                font-weight: 600;
                font-family: Poppins-Medium !important;
                color: #313131;
                margin: 0;
              "
            >
              Produtos
            </p>
          </div>

          <div
            style="
              display: flex;
              width: 100%;
              flex-direction: column;
              gap: 1rem;
              margin-top: 0.8rem;
              padding: 0 0.8rem;
            "
          >
            <table>
              <thead>
                <th>PRODUTO</th>
                <th>TIPO</th>
                <th>QTD</th>
                <th>VALOR UN.</th>
                <th>DESC</th>
                <th style="text-align: center">TOTAL</th>
              </thead>

              <tbody>
                <tr v-for="product of getSale?.products" :key="product.id">
                  <td>
                    <p
                      style="
                        font-weight: 500;
                        font-family: Poppins-Medium !important;
                        margin: 0;
                      "
                    >
                      {{ product?.nome }}
                    </p>

                    <p
                      style="
                        color: gray;
                        margin: 0;
                        font-weight: 500;
                        font-family: Poppins-Medium !important;
                      "
                    >
                      {{ product?.dadosAdicionais }}
                    </p>
                  </td>
                  <td>
                    <p
                      :style="`
                        margin: 0;
                        font-size: 0.6rem;
                        font-weight: 500;
                        font-family: Poppins-Medium !important;
                        border: solid 1px gray;
                        border-radius: 50px;
                        padding:  0;
                        text-align: center;
                        color: ${
                          product?.typeProduct === 'simples' ? 'black' : 'green'
                        };
                        background-color: ${
                          product?.typeProduct === 'simples'
                            ? 'white'
                            : '#00800026'
                        }
                       `"
                    >
                      {{ product?.typeProduct }}
                    </p>
                  </td>
                  <td
                    style="
                      font-weight: 500;
                      font-family: Poppins-Medium !important;
                    "
                  >
                    {{ product?.quantidade }}
                  </td>
                  <td
                    style="
                      font-weight: 500;
                      font-family: Poppins-Medium !important;
                    "
                  >
                    {{ maskCurrency(product?.valorUnitario || 0) }}
                  </td>
                  <td
                    style="
                      font-weight: 500;
                      font-family: Poppins-Medium !important;
                    "
                  >
                    {{ maskCurrency(product?.desconto || 0) }}
                  </td>
                  <td style="text-align: center">
                    {{
                      maskCurrency(
                        handleGetTotalProdValue(product, getSale?.tipoDesconto)
                      )
                    }}
                  </td>
                </tr>

                <tr style="background-color: #8080fd1a">
                  <td
                    colspan="5"
                    style="
                      font-family: Poppins-Regular !important;
                      font-weight: 600;
                      color: rgb(62, 62, 62);
                      font-size: 0.7rem;
                      text-align: end;
                    "
                  >
                    Total:
                  </td>
                  <td
                    style="
                      font-family: Poppins-Bold !important;
                      font-weight: 600;
                      font-size: 0.85rem;
                      color: #0f74c5;
                      line-height: 1;
                      text-align: center;
                    "
                  >
                    {{ maskCurrency(handleGetTotal()) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div
          v-if="getSale?.bills?.length"
          class="customCard"
          style="
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 0.8rem;
            padding: 0 0 0.8rem 0;
          "
        >
          <div
            style="
              display: flex;
              gap: 0.5rem;
              align-items: center;
              padding: 0.8rem 1.2rem 0 1.2rem;
            "
          >
            <div style="color: #0f74c5">
              <b-icon-credit-card2-back scale="1.1" />
            </div>

            <p
              style="
                font-size: 0.8rem;
                font-weight: 600;
                font-family: Poppins-Medium !important;
                color: #313131;
                margin: 0;
              "
            >
              Pagamentos
            </p>
          </div>

          <div
            style="
              padding: 0.8rem 1.2rem 0 1.2rem;
              width: 100%;
              display: flex;
              flex-direction: column;
              gap: 0.8rem;
            "
          >
            <div
              v-for="(bill, index) of getSale?.bills"
              :key="bill.id"
              class="customCard"
              style="
                display: flex;
                justify-content: center;
                gap: 0.8rem;
                border: solid 1px #d5d5d5;
                flex-wrap: wrap;
              "
            >
              <div class="contentTitleAndSubtitle">
                <div style="display: flex; align-items: center; gap: 0.5rem">
                  <p
                    style="
                      font-size: 0.75rem;
                      margin: 0;
                      font-weight: 500;
                      font-family: Poppins-Bold !important;
                    "
                  >
                    Parcela {{ index + 1 }}/{{ getSale?.bills.length }}
                  </p>

                  <p
                    :style="`
                        margin: 0;
                        font-size: 0.6rem;
                        font-weight: 500;
                        font-family: Poppins-Medium !important;
                        border: solid 1px ${
                          bill?.situacao === 'Em aberto'
                            ? 'black'
                            : bill?.situacao === 'Pago'
                            ? 'green'
                            : '#704800'
                        };
                        border-radius: 50px;
                        padding: 0 0.5rem;
                        text-align: center;
                        color: ${
                          bill?.situacao === 'Em aberto'
                            ? 'black'
                            : bill?.situacao === 'Pago'
                            ? 'green'
                            : '#704800'
                        }
                        };
                        background-color: ${
                          bill?.situacao === 'Em aberto'
                            ? 'white'
                            : bill?.situacao === 'Pago'
                            ? 'rgb(0 128 0 / 10%)'
                            : 'color-mix(orange 20%, transparent)'
                        }
                       `"
                  >
                    {{ bill?.situacao }}
                  </p>
                </div>
                <p
                  style="
                    color: rgb(62, 62, 62);
                    margin: 0;
                    font-size: 0.65rem;
                    font-weight: 500;
                    font-family: Poppins-Medium !important;
                  "
                >
                  Vencimento:
                  {{ bill?.data.split(" ")[0].split("-").reverse().join("/") }}
                  {{
                    bill?.dataPagamento
                      ? ` • Pago em: ${bill?.dataPagamento
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")}`
                      : ""
                  }}
                </p>
              </div>

              <div style="display: flex; gap: 1rem">
                <div>
                  <p class="titlePayments" style="text-align: end">
                    Valor Total
                  </p>
                  <p class="subtitlePayments" style="text-align: end">
                    {{ maskCurrency(bill?.valorTotal) }}
                  </p>
                </div>

                <div>
                  <p class="titlePayments" style="text-align: end">
                    Valor Restante
                  </p>
                  <p class="subtitlePayments" style="text-align: end">
                    {{ maskCurrency(bill?.valorRestante) }}
                  </p>
                </div>

                <div>
                  <p class="titlePayments">Forma de Pagamento</p>
                  <p
                    class="subtitlePayments"
                    style="
                      font-weight: 500;
                      font-family: Poppins-Medium !important;
                    "
                  >
                    {{ bill?.tipoFormaPagamento }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { maskCurrency } from "../../utils/maskMoney";

export default {
  props: {
    modalName: {
      typeof: String,
      default: "modal-confirm",
    },
    sale: {
      typeof: Object,
    },
  },
  data() {
    return {
      maskCurrency: maskCurrency,
    };
  },
  methods: {
    closeModal() {
      this.$emit("modalClosed");
      this.$bvModal.hide(this.modalName);
    },
    handleGetTotalProdValue(prod, typeDiscount) {
      let discountValue = 0;
      if (typeDiscount === "Porcentagem") {
        const result = (prod.valorTotal * (prod.desconto / 100)).toFixed(2);

        discountValue = result;
      } else {
        discountValue = prod.desconto;
      }

      return prod.valorTotal - discountValue;
    },
    handleGetTotal() {
      if (this.getSale?.products?.length) {
        const total = this.getSale?.products?.reduce((prev, current) => {
          if (this.getSale?.tipoDesconto === "Porcentagem") {
            const result = (
              current.valorTotal *
              (current.desconto / 100)
            ).toFixed(2);

            prev += current.valorTotal - result;
          } else {
            prev += current.valorTotal - current.desconto;
          }

          return prev;
        }, 0);

        return total;
      }

      return 0;
    },
    handleGetTotalsBill() {
      return this.getSale?.bills?.reduce((prev, current) => {
        prev += current.valorPago;

        return prev;
      }, 0);
    },
  },
  computed: {
    getSale() {
      return this.sale;
    },
  },
};
</script>

<style scoped>
.titleModal {
  font-size: 1rem;
  color: #313131;
  font-weight: 600;
  margin: 0;
  font-family: Poppins-Medium !important;
}

/* MODAL STYLE */

::v-deep(.modal-body) {
  padding: 0;
}

::v-deep(.modal-content) {
  border-radius: 0.625rem;
}

.headerModal {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 1rem 1.2rem 0 1.2rem;
  border-radius: 0.5rem 0.5rem 0 0;
}

.contentCloseIcon {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(236, 79, 79, 0.205);
  border-radius: 50%;
  position: absolute;
  right: -10px;
  top: -10px;
  cursor: pointer;
  transition: ease-in all 0.1s;
}

.contentCloseIcon:hover {
  background-color: rgba(236, 79, 79, 0.478);
  transition: ease-in all 0.1s;
}

.contentTitleAndSubtitle {
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
}

.subtitleItems {
  font-size: 0.65rem;
  font-family: Poppins-Medium !important;
  font-weight: 600;
}

.titlePayments {
  margin: 0;
  font-size: 0.65rem;
  color: gray;
  font-weight: 500;
  font-family: Poppins-Medium !important;
}

.subtitlePayments {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 500;
  font-family: Poppins-Bold !important;
}

.titleCard {
  font-size: 0.6rem;
  color: gray;
  margin: 0;
  font-weight: 500;
  font-family: Poppins-Medium !important;
}

.contentIconAndText {
  display: flex;
  flex: 1 1 200px;
  justify-content: flex-start;
  padding: 0 1.2rem 0 0.8rem;
  gap: 0.5rem;
  min-width: 0;
}

.subtitleCard {
  font-size: 1rem;
  margin: 0;
  font-weight: 600;
  font-family: Poppins-Bold !important;
  color: #313131;
}

.bodyModal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  justify-content: space-around;
  padding: 1rem 1.2rem;
}

.customCard {
  flex: 1 1 auto;
  outline: none;
  border: none;
  border-radius: 8px;
  box-shadow: 0 1px 2px 1px rgba(172, 172, 172, 0.144);
  transition: ease-in all 0.1s;
  display: flex;
  align-items: center;
  padding: 0.8rem 1.2rem;
  justify-content: space-between;
  border: 1px solid rgb(231, 231, 231);
}

.customCard .contentIcon {
  width: 35px;
  height: 35px;
  min-width: 35px;
  min-height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.basicInfoIcon {
  color: #0f74c5;
  border-radius: 8px;
  width: 27px;
  height: 27px;
  min-height: 27px;
  min-width: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: color-mix(in oklab, blue 10%, transparent);
}

table thead th {
  font-size: 0.6rem;
  font-weight: 600;
  color: rgb(62, 62, 62);
  font-family: Poppins-Regular !important;
}

table tbody td {
  font-size: 0.7rem;
  font-family: Poppins-Bold !important;
}

td,
th {
  padding: 0.5rem;
  border-bottom: solid 1px rgb(228, 228, 228);
}

td {
  padding: 0.8rem 0.5rem;
}
</style>